import { CloseCircleOutlined } from "@ant-design/icons";
import { Space, Tag, Typography } from "antd";
import type React from "react";
import { useIntl } from "react-intl";

type Props = {
  title: string;
  actualSize: number;
  minSize?: number | null;
  maxSize?: number | null;
};

export const LimitMinMaxSize: React.FC<Props> = ({ title, actualSize, minSize, maxSize }: Props) => {
  const { formatMessage } = useIntl();
  const isValid = (!minSize || actualSize >= minSize) && (!maxSize || actualSize <= maxSize);

  return (
    <Space>
      <Typography.Text strong>{title}</Typography.Text>
      <Tag icon={!isValid ? <CloseCircleOutlined /> : ""} color={!isValid ? "red" : ""} style={{ fontSize: "16px" }}>
        {actualSize} / {maxSize || formatMessage({ id: "valueIsNotSet" })}
      </Tag>
    </Space>
  );
};
